<template>
  <b-modal
    :id="modalId"
    ref="modalInsufficientCredit"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="!p-0"
    dialog-class="modal-dialog-centered !max-w-[440px] !w-full mx-auto"
    content-class="!rounded-[24px] !border-0 overflow-hidden bg-white"
  >
    <div class="bg-white rounded-[24px] p-8 w-full mx-auto flex flex-col items-center">
      <!-- Icon -->
      <div class="flex items-center justify-center mb-6">
        <img
          src="@/assets/images/icons/fail.svg"
          alt="Error"
          width="100"
          height="100"
          class="w-[100px] h-[100px]"
          @error="handleImageError"
        >
      </div>

      <!-- Text -->
      <h4 class="text-center font-semibold text-[20px] text-[#1f1f1f] mb-2 mt-0">
        Generate Video Gagal, Kredit Tidak Mencukupi
      </h4>
      <p class="text-center text-[#8c8c8c] text-sm leading-[1.5] mb-8 mt-0">
        Gagal generate video karena kredit yang kamu miliki tidak mencukupi. Top up terlebih dahulu untuk melanjutkan.
      </p>

      <!-- Actions -->
      <div class="flex w-full gap-4">
        <button
          type="button"
          class="flex-1 h-[48px] rounded-[16px] font-medium text-sm text-[#1f1f1f] bg-white border border-[#ece7e2] shadow-[0_2px_8px_rgba(0,0,0,0.08)] hover:bg-[#fafafa] m-0 transition-all duration-200 outline-none focus:outline-none flex items-center justify-center cursor-pointer"
          @click="handleClose"
        >
          Batal
        </button>
        <button
          type="button"
          class="flex-1 h-[48px] rounded-[16px] font-medium text-sm text-white bg-[#ff6a13] hover:bg-[#ff7d32] border-0 m-0 transition-all duration-200 outline-none focus:outline-none flex items-center justify-center cursor-pointer text-nowrap"
          @click="handleTopup"
        >
          Top Up
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
    handleTopup() {
      this.handleClose()
      this.$emit('topup')
    },
    handleImageError(e) {
      // Fallback if the error.svg doesn't exist on Komerce storage
      e.target.outerHTML = `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="40" fill="#FF4D4F"/>
        <path d="M60 40L40 60M40 40L60 60" stroke="white" stroke-width="8" stroke-linecap="round"/>
      </svg>`
    },
  },
}
</script>
